import React from 'react';

import MetaTags from 'components/meta-tags';
import { CircleStar } from 'src/assets/circle-star';
import { IrlEventTrackingEvent } from 'src/gql/graphql';
import { Card } from './card';
import { ContentHeader, Heading, Description, ShopNowButton, LogoWrapper, Content } from './styles';
import { useIrlEventTracking } from '../hooks/use-irl-event-tracking';

type IrlEventClosedProps = {
  shopNowUrl: string | null;
};

const CLOSED_TITLE = 'This event has ended';
const CLOSED_DESCRIPTION =
  "This event is no longer available, but there's still plenty to explore. Browse our latest offers and discover what's new.";

export function IrlEventClosed({ shopNowUrl }: IrlEventClosedProps): JSX.Element {
  const { trackEvent } = useIrlEventTracking();

  const handleShopNowClick = (): void => {
    void trackEvent(IrlEventTrackingEvent.shopNowClicked);
  };

  return (
    <>
      <MetaTags title={CLOSED_TITLE} description={CLOSED_DESCRIPTION} />

      <Card data-testid='irl-event-closed'>
        <LogoWrapper $showError>
          <CircleStar />
        </LogoWrapper>

        <ContentHeader>
          <Heading>{CLOSED_TITLE}</Heading>
          <Description>{CLOSED_DESCRIPTION}</Description>
        </ContentHeader>

        <Content narrow>
          {shopNowUrl && (
            <ShopNowButton
              href={shopNowUrl}
              target='_blank'
              rel='noopener noreferrer'
              variant='primary'
              size='large'
              onClick={handleShopNowClick}
              data-testid='irl-event-closed-shop-now-button'
            >
              Shop Now
            </ShopNowButton>
          )}
        </Content>
      </Card>
    </>
  );
}
